import '../styles/SignUpAccountExplanation.css';
import React from 'react';

const LEDGER = [
  { key: 'Crawls', val: 'Each crawl keeps its starting targets, status and progress.' },
  { key: 'Leads', val: 'Extracted email addresses keep the source page they were found on.' },
  { key: 'Sessions', val: 'Records stay tied to your account when you leave and return.' },
];

function RuleMark() {
  return (
    <span className="sua-mark" aria-hidden="true">
      <svg viewBox="0 0 34 18" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 9 H13" />
        <path d="M21 9 H33" />
        <path d="M14.5 3.5 L17 9 L14.5 14.5" />
        <path d="M19.5 3.5 L17 9 L19.5 14.5" />
        <circle cx="17" cy="9" r="1" fill="currentColor" stroke="none" />
      </svg>
    </span>
  );
}

function SignUpAccountExplanation() {
  return (
    <section className="sua-root" aria-labelledby="sua-heading">
      <div className="sua-rail" data-content-rail="reading">
        <div className="sua-opener">
          <RuleMark />
          <p className="sua-label">Why an account</p>
        </div>

        <h2 className="sua-heading" id="sua-heading">
          Your crawl and lead records stay yours.
        </h2>

        <p className="sua-copy">
          An account is what keeps a crawl from being a one-off search. The crawls
          you start and the email leads they reveal are tied to you, so you can
          close the browser and pick the same work up in a later session.
        </p>

        <p className="sua-copy">
          No crawl or lead list is shared with another researcher. You reach them
          through Crawls and Leads after you sign in.
        </p>

        <dl className="sua-ledger">
          {LEDGER.map((row) => (
            <div className="sua-ledger-row" key={row.key}>
              <dt className="sua-ledger-key">{row.key}</dt>
              <dd className="sua-ledger-val">{row.val}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export default SignUpAccountExplanation;